import { TransferOrderStatus } from '../constants/transfer-order-status.js';
export const IN_TRANSIT_TRANSFER_ORDER_STATUSES = [
    TransferOrderStatus.SHIPPED,
    TransferOrderStatus.PARTIALLY_RECEIVED,
];
//# sourceMappingURL=in-transit-transfer-order-statuses.js.map